module.exports = __webpack_public_path__ + "img/cc-amex.e5bf0c8d.svg";